import type { ReactNode } from 'react';
import cx from 'clsx';

import useNonLoginPopupStore from '~/store/global/useNonLoginPopupStore';

import { CartIcon } from '~/assets/icons';

type Props = {
  className?: string;
  children?: ReactNode;
};

const NonLoginShoppingCartButton = ({ className, children }: Props) => {
  const { openPopup } = useNonLoginPopupStore();

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();

    openPopup();
  };

  return (
    <div
      className={cx(
        ['bg-transparent active:bg-transparent w-32 h-32 mr-8 mb-8'],
        className,
      )}
    >
      <button
        type="button"
        className="flex w-full items-center justify-center"
        onClick={handleClick}
        data-testid="cart_shopping-cart-button"
      >
        {children || <CartIcon />}
      </button>
    </div>
  );
};

export default NonLoginShoppingCartButton;
